import Globals from "../core/Globals";
import Utils from "../core/Utils";
//
const Archiver = require("archiver");
const toBuffer = require("blob-to-buffer");
const StreamSaver = require("streamsaver");
//
export default class APIApplicationDownload {
  constructor(API, certProc, foreignItems, certSpecs, applicationType) {
    this.api = API;
    this.certProc = certProc;
    this.foreignItems = foreignItems;
    this.applicationType = applicationType;
    this.certSpecs = certSpecs;
  }
  async download() {
    //Get proper application specs
    let applicationSpecs = null;
    if (this.applicationType == Globals.ApplicationTypes.NEW)
      applicationSpecs = this.certSpecs.application;
    else if (this.applicationType == Globals.ApplicationTypes.RENEWAL)
      applicationSpecs = this.certSpecs.renewal.application;
    if (!applicationSpecs) throw new Error("Invalid application type!");
    const applicationProcess = this.certProc.applications.find(
      (applicationObject) =>
        applicationObject.type.toLowerCase() ==
        this.applicationType.toLowerCase()
    );
    //Check if we have items to download
    if (
      !applicationProcess.submissionItems ||
      (applicationProcess.submissionItems &&
        !applicationProcess.submissionItems.find((i) => {
          const item = this.certProc.applicationsItems.find(
            (appItem) =>
              appItem.sourceID == i.id && appItem.timestamp == i.version
          );
          return item.fileItems.length > 0;
        }))
    )
      throw new Error("No files available in the specified application!");

    //Start zip stream
    this.cs = this._getCompressionStream();

    //Interact through application
    //Equivalencies
    for (let opt of applicationSpecs && applicationSpecs.equivalenciesSection
      ? applicationSpecs.equivalenciesSection.options
      : [])
      await this._findAndDownloadOptionItem(opt, applicationProcess);
    //Application requirements ()
    for (let opt of applicationSpecs &&
    applicationSpecs.requirementsSection &&
    applicationSpecs.requirementsSection.requirements
      ? applicationSpecs.requirementsSection.requirements
      : [])
      await this._findAndDownloadOptionItem(opt, applicationProcess);
    //Custom requirements sections
    for (let section of applicationSpecs
      ? applicationSpecs.customRequirementsSections
      : []) {
      for (let opt of section ? section.requirements : [])
        await this._findAndDownloadOptionItem(opt, applicationProcess);
    }
    //Elective requirements
    for (let opt of applicationSpecs &&
    applicationSpecs.electiveRequirementsSection
      ? applicationSpecs.electiveRequirementsSection.requirements
      : [])
      await this._findAndDownloadOptionItem(opt, applicationProcess);

    //Close zip stream :)
    await this._closeAndCleanup();
    //
    return true;
  }

  /* private operations */
  _getCompressionStream() {
    const fileStream = StreamSaver.createWriteStream(
      `${this.certSpecs.title} - Application (${
        this.applicationType == Globals.ApplicationTypes.NEW
          ? "New applicant"
          : "Renewal"
      }).zip`
    );
    const archive = new Archiver("zip", { zlib: { level: 9 } });
    this.fileStream = fileStream.getWriter();
    archive.on("data", (d) => this.fileStream.write(d));
    return archive;
  }
  async _findAndDownloadOptionItem(opt, applicationProcess) {
    let item = this._getMatchingItem(
      opt,
      applicationProcess.submissionItems || [],
      this.foreignItems
    );
    // console.debug('Match', opt.id, item);
    //If normal submission item, find application item and normalize
    if (item && item.version)
      item = this.certProc.applicationsItems.find(
        (appItem) =>
          appItem.sourceID == item.id && appItem.timestamp == item.version
      );
    //Download items if not a historic item
    if (item && !item.isHistoric) {
      //Download all files
      for (let file of item.fileItems) {
        if (!(await this._streamFile(file, item, opt))) {
          //Abort zip operation and abort file
          this.cs.abort();
          this.fileStream.abort();
          throw new Error(
            "Error while downloading one or more files, please, try again!"
          );
        }
      }
    }
  }
  async _streamFile(file, item, opt) {
    const fileResp = await this.api.applicationItemFile.download(
      this.certProc.userID,
      this.certProc.id,
      item.sourceID,
      file.fileID || file
    );
    if (fileResp.statusCode == 200 && fileResp.body) {
      let buffer = await this._safeData(fileResp.body);
      const fileType = Utils.getFileExtensionFromMimeType(fileResp.body.type);
      const { filename, extension } = Utils.splitFilenameAndExtension(
        file.fileName
      );
      await this.cs.append(buffer, {
        name: `${opt.name.replace(/[^a-z0-9]/gi, "_")}/${
          filename || file.fileName || file
        }.${extension || fileType}`,
      });
      buffer = null;
      return true;
    } else
      console.log("Error while retrieving file", fileResp, file, item, opt);
    return false;
  }
  async _safeData(blob) {
    return new Promise((resolve, reject) => {
      toBuffer(blob, (err, buffer) => (err ? reject(err) : resolve(buffer)));
    });
  }
  async _closeAndCleanup() {
    //Finalize zip and close file
    await this.cs.finalize();
    this.fileStream.close();
  }
  /* helpers */
  _getMatchingItem(option, submissionItems, foreignItems) {
    const higherMatch = submissionItems.find((submissionItem) =>
      option.acceptedProviders.find(
        (acceptedProvider) => submissionItem.id == acceptedProvider.id
      )
    );
    const lowerMatch =
      higherMatch ||
      foreignItems.find((foreignItem) =>
        option.acceptedProviders.find(
          (acceptedProvider) => foreignItem.sourceID == acceptedProvider.id
        )
      );
    return lowerMatch;
  }
}
